type BaseParams = {
  start?: number
  step?: number
}

type EndBased = {
  end: number
} & BaseParams

type CountBased = {
  count: number
} & BaseParams

type Params = EndBased | CountBased

const isEndBased = (data: Params): data is EndBased =>
  (data as EndBased)?.end !== undefined

export function createRange(
  data: Params,
  options?: { endInclusive?: boolean }
): number[] {
  const endInclusive = options?.endInclusive ?? true
  const endInclusiveOffset = endInclusive ? 1 : 0

  const start = data.start ?? 0
  const step = data.step ?? 1

  const res: number[] = []

  if (isEndBased(data)) {
    for (let i = start; i < data.end + endInclusiveOffset; i += step) {
      res.push(i)
    }
  } else {
    for (let i = 0; i < data.count; i += step) {
      res.push(i + start)
    }
  }

  return res
}
